import React, { useRef, useContext, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { v4 as uuidv4 } from 'uuid';
import { useFormLayout } from '../contexts/FormLayoutContext'; // Ensure path to context is correct

const withDrag = (Component, acceptedType) => {
    return ({ isNew, id, type, ...props }) => {
        const {
            setShowDropZones,
            handleDragStart,
            handleDragEnd
        } = useFormLayout(); // Accessing context for drag state and drop zone visibility management

        const ref = useRef(null);

        // Logging initial state after receiving props to check what setShowDropZones is
//        console.log("[withDrag] Received setShowDropZones:", setShowDropZones);

        // Generate a unique ID for new items at the start of the drag
        const generatedId = useRef(isNew ? uuidv4() : id).current;
//        console.log(`[withDrag] Generated or received ID for ${isNew ? 'new' : 'existing'} item:`, generatedId);
//        console.log(`[withDrag] Initial props received by HOC:`, { isNew, id, type, ...props });

        const [{ isDragging }, drag, preview] = useDrag({
            type: acceptedType,
            item: () => {
                const dragItem = {
                    id: generatedId,
                    type: type || acceptedType,
                    isNew: isNew,
                    ...props
                };
//                console.log('[withDrag] Drag item preparation:', dragItem);
                setShowDropZones(true);
                if (handleDragStart) {
                    handleDragStart(); // Ensuring drag start logic is implemented
                }
                return dragItem;
            },
            collect: monitor => {
                const isCurrentlyDragging = !!monitor.isDragging();
//                console.log(`[withDrag] Collecting drag state: isDragging = ${isCurrentlyDragging}`);
                return { isDragging: isCurrentlyDragging };
            },
            end: (item, monitor) => {
                if (monitor.didDrop()) {
//                    console.log(`[withDrag] Dropped item: ${item.id} into a valid drop target.`);
                } else {
//                    console.log(`[withDrag] Dragging ended without drop for item: ${item.id}`);
                }
                setShowDropZones(false);
                if (handleDragEnd) {
                    handleDragEnd(); // Ensuring drag end logic is implemented
                }
            },
        });

        useEffect(() => {
            if (isDragging) {
//                console.log(`[withDrag] Dragging started for item: ${generatedId}`);
            } else {
//                console.log(`[withDrag] Dragging not active for item: ${generatedId}`);
            }
        }, [isDragging, generatedId]);

        drag(ref);
        preview(ref);

        const style = {
            cursor: 'grab',
            opacity: isDragging ? 0.5 : 1,
        };

//        console.log("[withDrag] Rendering wrapped component with final props including setShowDropZones:", { ...props, id: generatedId, type: type || acceptedType, setShowDropZones });

        return (
            <div ref={ref} style={style}>
                <Component {...props} id={generatedId} type={type || acceptedType} setShowDropZones={setShowDropZones} />
            </div>
        );
    };
};

export default withDrag;
